import React from 'react'
import styled from 'styled-components'
import { Button } from '../../components/button'
import { NewsPaperFeedCard } from '../../components/newPaperFeedCard'
import { NavBar } from '../../components/navbar'
import { NewsSearch, ButtonContainer, DateInput, Publications } from '../nigerianapub'
import { InputContainer } from '../signup'
import { NewspaperData } from '../../newspaperdata'

import { getLandingPage } from '../features/landingpage/landingpageSlice'

import useFetch from '../../hook/useFetch'

import {
  InnerContainer,
  ImageContainer,
} from '../../components/newPaperFeedCard'

import { useDispatch, useSelector } from 'react-redux'
import { getRecentExternal } from '../features/public/publicSlice'


const NewsFeed = () => {

  const dispatch = useDispatch()


    const { landingPage, landingStatus} = useSelector(state => state?.landingPage)
    useFetch(getLandingPage);


  return (
    <Container>
      <NavBar />
      
      <BodyContainer>
        <h2>Newspaper Feed</h2>
        <p>Below are Nigerian publications made in Nigeria </p>

        
          <NewsSearch>
                <form>
                    <h5>Search Nigeriana Publications</h5>
                    <InputContainer>
                        
                        <input type="search" placeholder='Title' />
                    </InputContainer>

                    <InputContainer>
                        
                        <input type="search" placeholder='Author' />
                    </InputContainer>

                    <InputContainer>
                        
                        <input type="search" placeholder='Keyword' />
                    </InputContainer>

                    <InputContainer>
                        <label htmlFor="date">Date</label>
                        
                        <DateInput>
                            <input name='date' type="search" placeholder='Between year' />
                            <input name='date' type="search" placeholder='And year' />
                        </DateInput>
                        
                    </InputContainer>

                    <ButtonContainer>
                        <Button filled bgColor={'#2A870E'} noIcon text={'Search'} />
                        <Button filled bgColor={'#fa8072'} noIcon text={'Reset'} />
                    </ButtonContainer>

                </form>

                <Publications>

                <NewsCards>

                  {
                    NewspaperData?.map((newsPaper) => {
                      return (
                        // <NewsCard>
                          <NewsPaperFeedCard key={newsPaper.id} {...newsPaper} />
                        // </NewsCard>
                      )
                    }

                  )}

                </NewsCards>

                </Publications>

                {/* <NewsPaperFeedCard /> */}

          </NewsSearch>

        
        


      </BodyContainer>
    </Container>
  )
}

const Container = styled.section`
  
`

const BodyContainer = styled.div`
  width: 90%;
  max-width: 1250px;
  margin: 0 auto;
  padding-top: 30px;
  padding-bottom: 30px;
  flex-wrap: wrap;
`

const InnerSearch = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
`

const NewsCards = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  
  
  @media screen and (max-width: 600px){
    width: 100%;
  }
`

export {NewsFeed}